module.exports = __webpack_public_path__ + "static/media/RecursosMat-ensinoFund-curto.1b71b9f5.png";